import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { designMatchesV2Load } from 'portal/store/records/designMatchesV2/actions'

export const useDesignMatchesV2Loader = ({
  enabled = true
}: { enabled?: boolean } = {}) => {
  const dispatch = useDispatch()

  const { accountId, projectId, recordId } = useModuleIds()

  const reload = useCallback(() => {
    if (!enabled) {
      return
    }

    if (!accountId || !projectId || !recordId) {
      return
    }

    dispatch(designMatchesV2Load(accountId, projectId, recordId))
  }, [accountId, dispatch, enabled, projectId, recordId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, data } = useSelector((state: any) => {
    return state.records.designMatchesV2
  })

  return {
    loading,
    error,
    data,
    reload
  }
}
